import { render } from "./templateTaskEdit.vue?vue&type=template&id=2d2c720a&scoped=true&ts=true"
import script from "./templateTaskEdit.vue?vue&type=script&lang=ts"
export * from "./templateTaskEdit.vue?vue&type=script&lang=ts"

import "./templateTaskEdit.vue?vue&type=style&index=0&id=2d2c720a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2c720a"]])

export default __exports__